import { Verdict, useGetExamCenterProctorRequestVerdictsByIdQuery } from '@exam-center/graphql';
import { Box, PaperSection } from '@shared/components';
import { dayjs } from '@shared/utils';

import { ProctorRequestVerdictCard } from '../../components';
import { useProctorRequestDetails } from '../../providers';

import { getProctorRequestVerdictCardProps } from './utils';
export default function ProctorRequestRejectedVerdict() {
  const { proctorRequest } = useProctorRequestDetails();

  const { data } = useGetExamCenterProctorRequestVerdictsByIdQuery({
    variables: {
      getExamCenterProctorRequestByIdInput: {
        id: proctorRequest.id,
      },
    },
    skip: !proctorRequest.id,
  });

  const verdicts = data?.ecGetExamCenterProctorRequestById.examCenterProctorRequest.verdicts;

  const currentRejectedVerdict = (verdicts ?? []).find(
    (v) =>
      v.submittedAt !== null &&
      v.verdict === Verdict.Rejected &&
      dayjs(v.requestedAt).isSame(dayjs(proctorRequest.requestedAt)),
  );

  if (!currentRejectedVerdict) {
    return null;
  }

  const { comment, submittedAt, verdict } =
    getProctorRequestVerdictCardProps(currentRejectedVerdict);

  return (
    <PaperSection title='ผลการอนุมัติ'>
      <Box sx={{ p: (theme) => theme.spacing(6) }}>
        <ProctorRequestVerdictCard comment={comment} submittedAt={submittedAt} verdict={verdict} />
      </Box>
    </PaperSection>
  );
}
